var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E4F4FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6368 26.0291C17.4813 26.0291 17.3356 26.0046 17.1996 25.9557C17.0636 25.9067 16.9373 25.8243 16.8207 25.7085L11.8072 20.695C11.5935 20.4813 11.4913 20.2042 11.5006 19.8637C11.5099 19.5233 11.6218 19.2466 11.8364 19.0336C12.0501 18.8199 12.3222 18.713 12.6525 18.713C12.9829 18.713 13.2549 18.8199 13.4687 19.0336L17.6368 23.2018L27.5179 13.3206C27.7317 13.1069 28.0088 13 28.3492 13C28.6897 13 28.9664 13.1069 29.1794 13.3206C29.3931 13.5344 29.5 13.8115 29.5 14.1519C29.5 14.4924 29.3931 14.7691 29.1794 14.9821L18.4529 25.7085C18.3364 25.8251 18.21 25.9079 18.074 25.9568C17.938 26.0058 17.7923 26.0299 17.6368 26.0291Z",
    fill: "#0D83C5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/Done Icon.e6a57aeab6d1259b5010ae685dec5aa4.svg";
export { ForwardRef as ReactComponent };